"use strict";
const dropDown = function (handlerIn, handlerOut, interval = 150) {
    document.addEventListener('DOMContentLoaded', () => {
        const menuNode = document.querySelectorAll(this)[0];
        if ('undefined' !== typeof menuNode) {
            for (let i = 0; i < menuNode.children.length; i++) {
                let menuItem = menuNode.children[i];
                _handleEvents(menuItem, interval, handlerIn, handlerOut);
            }
        }
    });
};
String.prototype.dropDown = dropDown;
function _handleEvents(el, interval, handlerIn, handlerOut) {
    let setOpenInterval;
    el.addEventListener('mouseenter', () => {
        setOpenInterval = window.setTimeout(() => {
            handlerIn(el);
            clearTimeout(setOpenInterval);
        }, interval);
    });
    el.addEventListener('mouseleave', () => {
        clearTimeout(setOpenInterval);
        const intervalTimeout = setTimeout(() => {
            handlerOut(el);
            clearTimeout(intervalTimeout);
        }, 50);
    });
}
